import React from 'react';
import { IRadioGroupProps, RadioGroup } from '@blueprintjs/core';
import { TLCode } from '../../../../common/enums';
import { TranslatedMessage } from '../../translation';
import { Overwrite } from '../../../../typings/typings';

// tslint:disable-next-line:no-empty-interface
interface CommonRadioGroupInputProps extends IRadioGroupProps {}

export type RadioGroupInputProps = Overwrite<CommonRadioGroupInputProps, { label?: TLCode }>;

const renderRadioGroupInput = (props: CommonRadioGroupInputProps) => <RadioGroup {...props} />;

const RadioGroupInput = ({ label, ...otherProps }: RadioGroupInputProps) =>
  label ? (
    <TranslatedMessage id={label}>
      {(tanslatedText) => renderRadioGroupInput({ ...otherProps, label: tanslatedText })}
    </TranslatedMessage>
  ) : (
    renderRadioGroupInput({ ...otherProps })
  );

export default RadioGroupInput;
